var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"Index"}},[_c('div',{staticClass:"title mb-4"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"links"},[_c('a',{attrs:{"href":"https://github.com/Yurich84/laravel-vue-spa-skeleton"}},[_vm._v("github.com/Yurich84/laravel-vue-spa-skeleton")])])
}]

export { render, staticRenderFns }